import axios from 'axios';
import environmentConfig from '../config/environment-configs';

export const familyApi = axios.create({
  withCredentials: true,
  baseURL: environmentConfig.FAMILY_URL,
});
